import { useMemo } from "react"

import { Project } from "shared/types/Project"
import { SortOrder } from "shared/types/SortOrder"

import {
  sortProjectsAlphabetically,
  sortProjectsByCreatedAt,
  sortProjectsByUpdatedAt
} from "entities/projects/lib/sortProjects"

export enum ProjectSortKey {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  TITLE = "title"
}

interface UseProjectSortingArgs {
  projects: Project[]
  sortKey: ProjectSortKey
  sortOrder: SortOrder
}

export function useProjectSorting({
  projects,
  sortKey,
  sortOrder
}: UseProjectSortingArgs) {
  return useMemo(() => {
    switch (sortKey) {
      case ProjectSortKey.TITLE:
        return sortProjectsAlphabetically(projects, sortOrder)
      case ProjectSortKey.CREATED_AT:
        return sortProjectsByCreatedAt(projects, sortOrder)
      case ProjectSortKey.UPDATED_AT:
        return sortProjectsByUpdatedAt(projects, sortOrder)
      default:
        return projects
    }
  }, [projects, sortKey, sortOrder])
}
